import type { NextPage } from "next"
import { NextSeo } from "next-seo"
import Script from "next/script"

import EuProjects from "../components/eu-projects"

const structuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Kaunas, Lithuania",
    postalCode: "LT-50423",
    streetAddress: "Birželio 23-iosios 8",
  },
  email: "info@pirmaskodas.lt",
  legalName: "MB Pirmas kodas",
  name: "Pirmas kodas",
  telephone: "+37064139571",
  url: "https://pirmaskodas.lt/",
  sameAs: [
    "https://rekvizitai.vz.lt/imone/pirmas_kodas/",
    "https://geltoni.lt/imones/pirmas-kodas-mb/327992",
    "https://kontaktai24.lt/imone/mb-pirmas-kodas/",
    "https://okredo.com/lt-lt/imone/mb-pirmas-kodas-306129624",
    "https://pirmas-kodas.vizitinekortele.lt/",
    "https://www.tax.lt/imones/84367-pirmas-projektas-mb",
  ],
  founder: {
    "@type": "Person",
    name: "Aidis Stukas",
    sameAs: [
      "https://www.aidisstukas.com/",
      "https://github.com/aidiss",
      "https://www.linkedin.com/in/aidis-stukas-2895b68/",
      "https://twitter.com/aidis_stukas",
      "https://stackoverflow.com/users/2631229/aidis",
    ],
  },
}

const description =
  "MB „Pirmas kodas“ įgyvendina Europos Sąjungos bendrai finansuojamą projektą: išmanusis teisės asistentas „Teise.ai“, veikiantis pagal pažangius kalbos modelius."

const Home: NextPage = () => {
  return (
    <>
      <NextSeo
        title="Pirmas kodas"
        description={description}
        canonical="https://pirmaskodas.lt"
        openGraph={{
          url: "https://pirmaskodas.lt",
          title: "Pirmas kodas",
          description,
          images: [
            {
              url: "https://pirmaskodas.lt/main.png",
              width: 1200,
              height: 628,
              alt: "Pirmas kodas",
              type: "image/png",
            },
          ],
          site_name: "Pirmas kodas",
        }}
        twitter={{
          handle: "@pirmaskodas",
          cardType: "summary_large_image",
        }}
      />
      <Script
        id="schema-organization"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      ></Script>

      <article>
        <h1 className="text-3xl font-medium tracking-tight md:text-4xl">
          ES projektai
        </h1>
        <EuProjects emblemHref="/es-projektai" />
      </article>
    </>
  )
}

export default Home
